module.exports = __webpack_public_path__ + "img/ICONI_MV.bffa34f1.png";